// Delad helper: gör ett element till en modal.js-driven modal under
// lg-breakpointen (< 1024px) och tillbaka till statiskt innehåll på desktop.
// Delas av kategori-sidebaren (category-accordion.js) och arkivfiltren
// (woo-filters.js) som tidigare hade var sin nästan identiska kopia.

/**
 * @param {string} selector  CSS-selektor för wrapper-elementet.
 * @param {string} modalId   data-modal_id som modal.js öppnar mot på mobil.
 */
export function initResponsiveModal(selector, modalId) {
    const el = document.querySelector(selector)
    if (!el) return

    const update = () => {
        const closeBtn = el.querySelector('.close-btn')
        if (window.innerWidth >= 1024) {
            if (closeBtn) closeBtn.click()
            el.removeAttribute('data-modal_id')
            el.classList.remove('modal')
        } else {
            el.setAttribute('data-modal_id', modalId)
            el.classList.add('modal')
        }
    }

    update()
    window.addEventListener('resize', update)
}
